import {
  ORDER_CHANGE_BILLING_ADDRESS,
  ORDER_CHANGE_CUSTOMER, ORDER_CHANGE_PERSONA, ORDER_CHANGE_SHIPPING_ADDRESS,
  ORDER_CREATE,
  ORDER_CREATED,
  ORDER_REQUEST_DATA,
  ORDER_CREATED_FAILURE,
  ORDER_CUSTOMER_CREATED, ORDER_FORM_RESET,
  ORDER_FORM_VALUES
} from "./OrderActions";
import {TRANSACTION_TYPE_DEBIT} from "./OrderConstants";
import {FormUtils} from "../utils/FormUtils";

const orderFormInitialState = {
  amount: 2000,
  transactionType: TRANSACTION_TYPE_DEBIT,
  currency: 'EUR',
  allowedProducts: '',
  async: {
    successUrl: 'https://www.google.de/#newwindow=1&q=success',
    failureUrl: 'https://www.google.de/#newwindow=1&q=failure',
    cancelUrl: 'https://www.google.de/#newwindow=1&q=cancel',
    confirmUrl: 'https://www.google.de/?newwindow=1&q=confirm'
  },
  ipAddress: null,
  addBasket: true,
  addCustomer: false,
  addPersona: false,
  addBillingAddress: false,
  addShippingAddress: false,
  customer: null,
  persona: null,
  billingAddress: null,
  shippingAddress: null
};

const initialState = {
  loading: false,
  order: null,
  orderRequestData: null,
  error: null,
  transactionType: TRANSACTION_TYPE_DEBIT,
  customerCreated: false,
  orderForm: orderFormInitialState
};

export function order(state = initialState, action) {
  switch (action.type) {
    case ORDER_CREATE:
      return {
        ...state,
        loading: true
      };
    case ORDER_CREATED:
      return {
        ...state,
        loading: false,
        order: action.order,
        error: null
      };
    case ORDER_REQUEST_DATA:
      return {
        ...state,
        loading: false,
        orderRequestData: action.orderRequestData,
        error: null
      };
    case ORDER_CREATED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        order: null
      };
    case ORDER_FORM_VALUES:
      return {
        ...state,
        orderForm: action.formValues
      };
    case ORDER_CUSTOMER_CREATED:
      return {
        ...state,
        customerCreated: true
      };
    case ORDER_FORM_RESET:
      return {
        ...state,
        orderForm: orderFormInitialState
      };
    case ORDER_CHANGE_CUSTOMER:
    case ORDER_CHANGE_PERSONA:
    case ORDER_CHANGE_BILLING_ADDRESS:
    case ORDER_CHANGE_SHIPPING_ADDRESS:
      return {
        ...state,
        orderForm: orderForm(state.orderForm, action)
      };
    default:
      return state;
  }
}

export function orderForm(state = orderFormInitialState, action) {
  switch (action.type) {
    case ORDER_CHANGE_CUSTOMER:
      return {
        ...state,
        addCustomer: true,
        customer: action.action
      };
    case ORDER_CHANGE_PERSONA:
      return {
        ...state,
        addPersona: true,
        persona: action.action
      };
    case ORDER_CHANGE_BILLING_ADDRESS:
      return {
        ...state,
        addBillingAddress: true,
        billingAddress: action.action
      };
    case ORDER_CHANGE_SHIPPING_ADDRESS:
      return {
        ...state,
        addShippingAddress: true,
        shippingAddress: action.action
      };
    default:
      return state;
  }
}



export const getOrder = state => {
  return state.order.order;
};

export const getOrderForm = state => {
  return state.order.orderForm;
};

export const getOrderRequestData = state => {
  return state.order.orderRequestData;
}

export const getError = state => {
  return state.order.error;
};

export const isOrderLoading = state => {
  return state.order.loading;
};

export const getCreateOrderBody = (formValues) => {
  const requestBody = {
    'initialAmount': window.parseInt(formValues.amount),
    'currency': formValues.currency,
    'transactionType': formValues.transactionType,
    'allowedProducts': formValues.allowedProducts,
    'ipAddress': formValues.ipAddress
  };

  if (formValues.async) {
    requestBody['async'] = FormUtils.getNotEmptyValues(formValues.async);
  }

  if (formValues.addBasket) {
    requestBody['basket'] = [{
      'name': 'usbstick',
      'articleNumber': 'sasdfas',
      'totalPrice': window.parseInt(formValues.amount),
      'totalPriceWithTax': window.parseInt(formValues.amount),
      'unitPrice': window.parseInt(formValues.amount),
      'unitPriceWithTax': window.parseInt(formValues.amount),
      'tax': 0,
      'quantity': 1
    }];
  }

  if (formValues.addCustomer) {
    requestBody['customer'] = formValues.customer;
  }
  if (formValues.addCustomer && formValues.addPersona) {
    requestBody['persona'] = formValues.persona;
  }
  if (formValues.addCustomer && formValues.addBillingAddress) {
    requestBody['billingAddress'] = formValues.billingAddress;
  }
  if (formValues.addCustomer && formValues.addShippingAddress) {
    requestBody['shippingAddress'] = formValues.shippingAddress;
  }

  requestBody['terms'] = Date.now();
  requestBody['privacy'] = Date.now();

  return FormUtils.getNotEmptyValues(requestBody);
};



// WEBPACK FOOTER //
// ./src/order/OrderReducers.js